import "./IvAccountOpeningDialog.scss";
import template from "./IvAccountOpeningDialog.html";
import {IComponentOptions, IOnDestroy, IWindowService} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {ReplaySubject} from "rxjs";
import {Milestone} from "../../../services/milestone/MilestoneService";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {MilestoneStore} from "../../../services/milestone/MilestoneStore";

export const IvAccountOpeningDialog = "tfIvAccountOpeningDialog";

export function ivAccountOpeningDialog(): IComponentOptions {
    return {
        template,
        bindings: {
            modalInstance: "<"
        },
        controllerAs: "ctrl",
        controller: IvAccountOpeningDialogComponent
    };
}

export class IvAccountOpeningDialogComponent implements IOnDestroy {
    public readonly modalInstance: IModalInstanceService;

    private readonly start$ = new ReplaySubject<boolean>(1);
    private readonly destroy$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor($window: IWindowService,
                       milestoneStore: MilestoneStore,
                       currentUserService: CurrentUserService) {

        this.start$
            .takeUntil(this.destroy$)
            .withLatestFrom(currentUserService.current)
            .map(([_, user]) => user)
            .subscribe((user) => {
                milestoneStore.completeMilestone(Milestone.ACC_OPEN_STARTED);

                let url = "https://newaccount.impliedvolatility.com.au";
                // url += "?email=" + user.username;
                //
                // if (user.profile.phone) {
                //     url += "&Mobile%20Phone=" + user.profile.phone;
                // }
                //
                // if (user.profile.postCode) {
                //     url += "&Address-zip=" + user.profile.postCode;
                // }
                //
                // if (user.profile.givenName) {
                //     url += "&Name-first=" + user.profile.givenName;
                // }
                //
                // if (user.profile.surname) {
                //     url += "&Name-last=" + user.profile.surname;
                // }
                $window.open(url , "_blank");
            });
    }

    public start() {
        this.start$.next(true);
    }

    public dismiss() {
        this.modalInstance.dismiss();
    }

    public $onDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();

    }
}
